import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-states-page-ui',
    templateUrl: './bb-states-page-ui.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class BbStatesPageUiComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
